import '../Shared/common.scss';
import { InputLabel, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { Controller } from "react-hook-form";
import { CreditRatingFields, CreditRatingTitles } from '../../../models/credit-rating.model';

const CreditRatingToggle = ({
    control,
    label,
    name = "mileage",
    color = "primary",
    changeEvent,
}: any & {
    label?: string;
    name?: string;
    color?: string;
    changeEvent?: (...event: any[]) => void;
}) => {

    const uiTitle = CreditRatingTitles;

    return (
        <>
            <Controller
                key="crt-controller"
                name={name}
                control={control}
                render={({
                    field: { onChange, value },
                    fieldState: { error },
                    formState,
                }) => (
                    <>
                        <InputLabel htmlFor="toggle-group" key="crt-label">{label}</InputLabel>
                        <ToggleButtonGroup
                            id="toggle-group"
                            key="crt-toggle-group"
                            color={color}
                            value={value}
                            onChange={changeEvent}
                            >

                            { (Object.keys(CreditRatingFields) as Array<keyof typeof CreditRatingFields>).map((x => (
                                <ToggleButton key={"toggle-btn-"+ x} value={x}>{uiTitle.get(x)}</ToggleButton>
                            )))
                            }
                        </ToggleButtonGroup>
                    </>

                )}
            />
        </>
    );
};

export default CreditRatingToggle;
